<ng-content select=".top-pane"></ng-content>
<div class="resize-handle" #resizeHandle>
  <div class="resize-handle-center">
    <mat-icon>drag_handle</mat-icon>
  </div>
</div>
<ng-content select=".bottom-pane"></ng-content>
